//
//  src/layouts/default/contact/wizard/sent/Sent.js
//
import * as React from "react";
import EnquireOutcomeSent from "../../../../../components/enquire/EnquireOutcomeSent";
import "./Sent.css";

export default function WizardSent() {
    return (
        <EnquireOutcomeSent
            source="wizard"
            message={
                <p>
                    A confirmation is on its way to your email.<br />
                    I'll get back to you personally as soon as I can.
                </p>
            }
            secondary={
                <>
                    Didn't receive a confirmation? Email me directly at{" "}
                    <a href="mailto:jeff@jefftattooer.com">jeff@jefftattooer.com</a>.
                </>
            }
        />
    );
}
